import React from "react";
import { StyledButton } from "../../../../Styled-Components/styles";

const EasyDonateButton = (props) => {
  return (
    <StyledButton
      style={{ marginLeft: "1vw", marginRight: "1vw" }}
      selected={props.payment === props.value}
      onClick={() => props.setPayment(props.value)}
    >
      £{props.value}
    </StyledButton>
  );
};

export default EasyDonateButton;
